(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const links = document.querySelectorAll('.footer-block--menu .footer-block__heading');
  
  links.forEach(link => {
    link.addEventListener('click', function() {
      const menu = link.nextElementSibling;  // Use nextElementSibling instead of nextSibling
  
      // Toggle menu visibility more robustly
      if (menu.style.display === "none" || menu.style.display === "") {
        menu.style.display = "block";
      } else {
        menu.style.display = "none";
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
